import Button from '@mui/material/Button';
import useNewQuestion from '../../../hooks/useNewQuestion';
import Form from '../baseComponents/form';
import Input from '../baseComponents/input';
import TextArea from '../baseComponents/textarea';
import useLayoutStyles from '../../layout/useLayoutStyles';
import useGlobalStyles from '../../useGlobalStyles';

/**
 * NewQuestionPage component allows users to submit a new question with a title,
 * description, tags, and username.
 */
const NewQuestionPage = () => {
  const { classes: layoutClasses } = useLayoutStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const {
    title,
    setTitle,
    text,
    setText,
    tagNames,
    setTagNames,
    titleErr,
    textErr,
    tagErr,
    postQuestion,
  } = useNewQuestion();

  return (
    <div className={layoutClasses.pageContainer}>
      <Form>
        <Input
          title={'Question Title'}
          hint={'Limit title to 100 characters or less'}
          id={'formTitleInput'}
          val={title}
          setState={setTitle}
          err={titleErr}
        />
        <TextArea
          title={'Question Text'}
          hint={'Add details'}
          id={'formTextInput'}
          val={text}
          setState={setText}
          err={textErr}
        />
        <Input
          title={'Tags'}
          hint={'Add keywords separated by whitespace'}
          id={'formTagInput'}
          val={tagNames}
          setState={setTagNames}
          err={tagErr}
        />
        <div className={layoutClasses.btnIndicatorContainer}>
          <Button
            className={`${globalClasses.button} ${layoutClasses.formPostBtn}`}
            onClick={() => {
              setTimeout(() => {
                postQuestion();
              }, 200);
            }}>
            Post Question
          </Button>
          <div className={globalClasses.mandatoryField}>
            *{' '}
            <span className={globalClasses.indicatesMandatoryText}>indicates mandatory fields</span>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default NewQuestionPage;
